var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-1 text-center text-muted"},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"cursor-pointer",staticStyle:{"font-size":"14px"},attrs:{"title":_vm.tooltip}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }